import { useState } from 'react';

import { SessionStrip, type TerminalTabState } from './terminal/SessionStrip';
import { TerminalSurface } from './terminal/TerminalSurface';

let nextKey = 0;
function newTab(label: string): TerminalTabState {
  nextKey += 1;
  return { key: `term-${nextKey}`, label, ptySessionId: null };
}

export function TerminalTab({ base }: { base: string }) {
  const [tabs, setTabs] = useState<TerminalTabState[]>(() => [newTab('zsh 1')]);
  const [activeKey, setActiveKey] = useState(() => tabs[0]!.key);

  const addTab = () => {
    const tab = newTab(`zsh ${tabs.length + 1}`);
    setTabs((prev) => [...prev, tab]);
    setActiveKey(tab.key);
  };

  const closeTab = (key: string) => {
    setTabs((prev) => {
      const next = prev.filter((t) => t.key !== key);
      if (activeKey === key && next.length > 0) setActiveKey(next[0]!.key);
      return next;
    });
  };

  const setPtySessionId = (key: string, ptySessionId: string) => {
    setTabs((prev) => prev.map((t) => (t.key === key ? { ...t, ptySessionId } : t)));
  };

  return (
    // The xterm theme's own background (TerminalSurface), not a token: the terminal is dark in both
    // themes, and `code-bg` only has this value in dark mode.
    <div className="flex min-h-0 flex-1 flex-col bg-[#0c0e16]">
      <SessionStrip tabs={tabs} activeKey={activeKey} onSelect={setActiveKey} onAdd={addTab} onClose={closeTab} />
      <div className="relative min-h-0 flex-1">
        {tabs.map((tab) => (
          <div
            key={tab.key}
            className="absolute inset-0"
            style={{ pointerEvents: activeKey === tab.key ? 'auto' : 'none' }}
          >
            <TerminalSurface
              base={base}
              ptySessionId={tab.ptySessionId}
              onSessionId={(id) => setPtySessionId(tab.key, id)}
              active={activeKey === tab.key}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
